function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 2.3h2.7V5h-1.6c-.9 0-.8.3-.8 1.4v.8h2.4l-.4 2.8h-2v7.6H8V10H6.3V7.3H8V5s0-1.3 1-2.1c.9-.7 2-.6 2-.6"
});

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "facebook",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgFacebook;